import { render, staticRenderFns } from "./ToggleWsPopupsBtn.vue?vue&type=template&id=24c003c2&"
import script from "./ToggleWsPopupsBtn.vue?vue&type=script&lang=ts&"
export * from "./ToggleWsPopupsBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports